import { useEffect } from 'react';

export const GTMManager = () => {
  const GMT_ID = 'GTM-TTCJ7QFX';
  useEffect(() => {
    // Inject the GTM script in the head
    const headScript = document.createElement('script');
    headScript.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GMT_ID}');
    `;
    document.head.appendChild(headScript);

    // Create body script as a noscript tag (useful if you're server-side rendering)
    const bodyScript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GMT_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    bodyScript.appendChild(iframe);
    document.body.insertBefore(bodyScript, document.body.firstChild);

    // Cleanup function to remove scripts when the component unmounts
    return () => {
      document.head.removeChild(headScript);
      document.body.removeChild(bodyScript);
    };
  }, [GMT_ID]); // Only re-run the effect if gtmId changes

  return null; // This component doesn't render anything
};
